import React from "react";
import FormInputs from "../../../../../../components/UI/FormInputs";
import Icons from "../../../../../../components/UI/Icons";
import { isSet } from "../../../../../../utils/commonUtils";

const ResultNotesWithSendMessage = ({
  itemIndex,
  column,
  label,
  name,
  formData,
  changeHandler,
  resultActionFieldName,
  resultActionOptions = [],
  sendMessageClickHandler,
  className = "form-control form-control-solid",
  placeholder = "",
  rows = 3,
  validation,
  readOnly,
  col,
  showContainerBorder,
  hideSendButton = false,
  ...props
}) => {
  const value = isSet(formData[name], "");
  const resultActionValue = isSet(formData[resultActionFieldName], "");
  const taskTitleLabel =
    resultActionOptions.find((o) => String(o.value) === String(resultActionValue))?.label || resultActionValue || "";

  const notesEmpty = !String(value || "").trim();
  const noActionNeeded = String(resultActionValue || "") === "no_action_needed";
  const isSendDisabled = notesEmpty || noActionNeeded;

  const handleSendMessageClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isSendDisabled || !sendMessageClickHandler) return;
    sendMessageClickHandler(taskTitleLabel, value || "");
  };

  return (
    <div className={`${column || "col-12"} ${showContainerBorder ? "border border-left-0" : ""} py-1`} key={itemIndex}>
      <div className="form-group mb-0">
        {label ? (
          <label className="col-sm-12 f-400 text-sm mb-1 opacity-75 d-block" title={label}>
            {label}
          </label>
        ) : null}
        <div className={hideSendButton ? "" : "d-flex align-items-start gap-2 flex-nowrap"}>
          <div className={hideSendButton ? "" : "flex-grow-1 min-w-0"}>
            <FormInputs
              {...props}
              type="TextArea"
              name={name}
              value={value}
              changeHandler={(val) => changeHandler(name, val)}
              className={className}
              placeholder={placeholder}
              rows={rows}
              validation={validation}
              readOnly={readOnly}
            />
            {isSet(validation?.[name], "") !== "" ? (
              <span className="text-danger m-1">{isSet(validation[name], "")}</span>
            ) : null}
          </div>
          {!hideSendButton && (
            <button
              type="button"
              className={`btn btn-sm d-inline-flex align-items-center gap-2 flex-shrink-0 px-3 ${isSendDisabled ? "btn-secondary opacity-75" : "btn-primary"}`}
              title={isSendDisabled ? (notesEmpty ? "Add notes to send a message" : "Select an action other than No Action Needed to send") : "Send Message"}
              onClick={(e) => handleSendMessageClick(e)}
              aria-label="Send Message"
              disabled={isSendDisabled}
            >
              <span>Send Message</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultNotesWithSendMessage;
